import { render, staticRenderFns } from "./CreateAlarm.vue?vue&type=template&id=2b089278"
import script from "./CreateAlarm.vue?vue&type=script&lang=js"
export * from "./CreateAlarm.vue?vue&type=script&lang=js"
import style0 from "./CreateAlarm.vue?vue&type=style&index=0&id=2b089278&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports